import React, { useState, useEffect } from 'react';
import faqData from './icfaqData.json';

const IcFAQPage = () => {

  const [searchQuery, setSearchQuery] = useState('');
  const [openItem, setOpenItem] = useState(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  const filteredFaqs = faqData.reduce((acc, item) => {
    const existing = acc.find(i => i.heading === item.heading);
    const subEntry = {
      subheading: item.subheading,
      faqs: item.faqs.filter(faq =>
        (faq.question || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        (faq.answer || "").toLowerCase().includes(searchQuery.toLowerCase())
      )
    };

    if (!subEntry.faqs.length) return acc;

    if (existing) {
      existing.subsections.push(subEntry);
    } else {
      acc.push({
        heading: item.heading,
        subsections: [subEntry]
      });
    }
    return acc;
  }, []);

  const renderIcAnswerWithBullets = (answer) => {
    return answer.split('\n').map((line, index) => {
      const trimmed = line.trim();

      const formatBold = (text) => {
        const parts = text.split(/(\*\*.*?\*\*)/g);
        return parts.map((part, i) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
          }
          return part;
        });
      };

      if (trimmed.startsWith('•')) {
        return (
          <div key={index} className="d-flex align-items-start mb-1">
            <div style={{ marginRight: '8px', marginTop: '0px' }}>•</div>
            <span>{formatBold(trimmed.substring(1).trim())}</span>
          </div>
        );
      }
      else if (trimmed.startsWith('◦')) {
        return (
          <div key={index} className="d-flex align-items-start mb-1" style={{ paddingLeft: '20px' }}>
            <div style={{ marginRight: '8px', marginTop: '0px' }}>◦</div>
            <span>{formatBold(trimmed.substring(1).trim())}</span>
          </div>
        );
      }
      else {
        return <p key={index} className="mb-1">{formatBold(line)}</p>;
      }
    });
  };




  return (
    <div className="page__main" >
      <div className="dashboard" style={{ minHeight: '100vh' }}>
        <div className="container-fluid">
          <div className="row d-flex align-items-center justify-content-between">
            <div className="mt-3 w-75">
              <h2 className="fw-semibold font-26 mb-2">FAQ Page</h2>
              <p>All your doubts resolved in one page</p>
            </div>
            <div className="mt-3 w-25">
              <input
                type="text"
                className="form-control"
                placeholder="Search FAQs..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Grouped FAQs */}
          {filteredFaqs.length > 0 ? (
            filteredFaqs.map((section, sectionIdx) => (
              <div key={sectionIdx} className="mb-4 mt-2 ">
                <h2 className="fw-bold mb-3" style={{ fontSize: '20px' }}>{section.heading}</h2>

                <div className="p-4 rounded-lg" style={{
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                  borderRadius: '8px'
                }}>
                  {section.subsections.map((sub, subIdx) => (
                    <div key={subIdx} className="mb-4">
                      <h5 className="fw-semibold mb-4 " style={{ fontSize: '18px', color: '#156B90' }}>{sub.subheading}</h5>

                      {sub.faqs.map((faq, faqIdx) => {
                        const uniqueKey = `${sectionIdx}-${subIdx}-${faqIdx}`;
                        const isOpen = openItem === uniqueKey;

                        return (
                          <div key={uniqueKey} className="mb-4">
                            <div
                              className="d-flex justify-content-between align-items-start cursor-pointer"
                              onClick={() => setOpenItem(prev => (prev === uniqueKey ? null : uniqueKey))}
                              style={{ cursor: 'pointer' }}
                            >
                              <span
                                className="fw-semibold mt-1 mb-1 text-lg"
                                style={{ color: isOpen ? '#156b90' : 'inherit' }}
                              >
                                {faq.question}</span>
                              <span>
                                {isOpen ? (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8z" />
                                  </svg>
                                ) : (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 4a.5.5 0 0 1 .5.5V7.5H11a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V8.5H5a.5.5 0 0 1 0-1h2.5V4.5A.5.5 0 0 1 8 4z" />
                                  </svg>
                                )}
                              </span>
                            </div>

                            {isOpen && (
                              <div className="mt-2 answer-box">{renderIcAnswerWithBullets(faq.answer)}</div>
                            )}
                            <hr className="mt-3 mb-2" />
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p className="mt-4">No FAQs matched your search.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default IcFAQPage;